import { Component } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { GbeigentumService, GbgrundstueckService, GrundstueckId, GrundstueckListEntry } from '../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { OerebService } from '../../core/oereb-api';
import { catchError, map, tap } from 'rxjs/operators';
import { ListLoaderObservable } from '../../shared/components/list-loader/list-loader-observable';
import { ListLoader } from '../../shared/components/list-loader/list-loader';
import { AbstractGrundstueckEntryFromRoute } from '../../grundstueck/grundstueck-rubriken/abstract-grundstueck-entry-from.route';
import { ActivatedRoute, Router } from '@angular/router';
import { TimepointService } from '../../core/services/timepoint.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { EMPTY, Observable } from 'rxjs';
import { OerebStateService } from '../services/oereb-state.service';
import { OerebWrapperComponent } from '../oereb-wrapper/oereb-wrapper.component';
import { KompaktGrundstueckComponent } from '../../shared/kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import { ListLoaderWrapperComponent } from '../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'cap-oereb-uebersicht',
  templateUrl: './oereb-table-uebersicht.component.html',
  imports: [OerebWrapperComponent, KompaktGrundstueckComponent, ListLoaderWrapperComponent, NgTemplateOutlet, AsyncPipe, TranslatePipe]
})
export class OerebTableUebersichtComponent extends AbstractGrundstueckEntryFromRoute {
  hasData: Observable<boolean>;
  listLoader: ListLoader<string>;
  stockwerkOrMiteigentum: boolean;
  oerebServiceNichtVerfuegbar: boolean;
  oereb_grundstueckId: GrundstueckId;
  stammgrundstueck$: Observable<GrundstueckListEntry>;

  constructor(
    private oerebService: OerebService,
    private translate: TranslateService,
    protected route: ActivatedRoute,
    protected grundstueckService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected appConfigService: AppConfigService,
    protected router: Router,
    protected oerebStateService: OerebStateService,
    protected eigentumService: GbeigentumService
  ) {
    super(route, grundstueckService, timepointService, appConfigService, router);
    keysToTranslate<string>(['oereb.KeineOderNochKeineDatenVorhanden']);
    this.hasData = this.oerebStateService.hasData$;
  }

  protected loadData() {
    this.oereb_grundstueckId = this.grundstueckEntry.id;
    this.stockwerkOrMiteigentum = ['STOCKWERK', 'MITEIGENTUM'].includes(this.grundstueckEntry.grundstueckArt);
    if (this.stockwerkOrMiteigentum) {
      this.addSub(
        this.eigentumService.loadBodengrundstueckVon(this.grundstueckEntry.id.id).subscribe((grundstueck_id) => {
          this.oereb_grundstueckId = grundstueck_id;
          this.reloadData();
          this.stammgrundstueck$ = this.grundstueckService.loadGrundstueckListEntryById(this.oereb_grundstueckId.id);
        })
      );
    } else {
      this.reloadData();
      this.stammgrundstueck$ = EMPTY;
    }
    this.addSub(this.translate.onLangChange.subscribe(() => this.reloadData()));
  }

  private createLoader(): ListLoader<string> | ListLoader<any> {
    const observable = this.oerebService.getUebersichtOerebs(this.oereb_grundstueckId.id, this.translate.getCurrentLang()).pipe(
      catchError((err) => this.handleError(err)),
      tap((s) => this.oerebStateService.hasData.next(!s.keineDatenVorhanden)),
      map((s) => s.oerebsBetreffenGrundstueck)
    );
    const loader = new ListLoaderObservable(100, 1, observable);
    this.addLoader(loader);
    return loader;
  }

  private reloadData() {
    if (this.listLoader) {
      this.listLoader.unsubscribeAll();
    }
    this.listLoader = this.createLoader();
  }

  private handleError(err: any): Observable<any> {
    if (err.status === 502) {
      this.oerebServiceNichtVerfuegbar = true;
    } else {
      throw err;
    }
    return EMPTY;
  }
}
